import { render, staticRenderFns } from "./ResumenDeportistas.vue?vue&type=template&id=b5a7e25e"
import script from "./ResumenDeportistas.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumenDeportistas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports